import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import classes from './index.module.scss'

const TitlePanel = ({ title, subTitle }) => {
  return (
    <Element
      className={`fw600 ${classes.textEllipsisTwoLine}`}
      style={{
        backgroundColor: '#E0E0E0',
        color: '#033363',
        fontSize: 15,
        padding: '4px 12px',
      }}
    >
      <span>{title}</span>
      {subTitle && (
        <Translate
          value={subTitle}
          style={{
            fontStyle: 'italic',
            fontWeight: 400,
            paddingLeft: 4,
          }}
        />
      )}
    </Element>
  )
}

TitlePanel.propTypes = {
  title: PropTypes.string.isRequired,
}

export default TitlePanel
